import request from "../utils/request";

/**
 * @typedef {Object} LoginForm
 * @property {String} username_email
 * @property {String} password
 * @property {String} method
 */

/**
 *
 * @param {LoginForm} data { username/email, password}
 * @returns
 */

export function login({ username, password }) {
  const payload = { username, password };
  const url = "/auth/login/";

  return request({
    url,
    method: "post",
    data: payload,
  });
}

export function getInfo() {}

/**
 *@todo Implement function
 */
export function logout() {
  // return new Promise((resolve) => {
  //   setTimeout(() => resolve(true), 1);
  // });
  return request({
    url: "/auth/logout/",
    method: "get",
  });
}

/**
 *
 * @param {String} email
 * @returns
 */
export function forgotPassword(email) {
  return request({
    // url: "/accounts/users/forgot_password/",
    url: "/auth/password/forget/",
    method: "post",
    data: {
      email,
    },
  });
}

/**
 *
 * @param {Object} data
 * @returns
 */
export function resetPassword(data) {
  return request({
    url: "/auth/password/reset/",
    method: "post",
    data,
  });
}
